import Vue from 'vue'
import VueRouter from 'vue-router'
import store from "../store"
import { getWxUserInfo } from "../common/checkLogin"

//解决 在VUE中路由遇到Error: Avoided redundant navigation to current location:报错显示是路由重复
const originalPush = VueRouter.prototype.push
   VueRouter.prototype.push = function push(location) {
   return originalPush.call(this, location).catch(err => err)
}

const Main = () => import('../views/home/main')
const Home = () => import('../views/home/index')
const SchoolList = () => import('../views/home/schoolList')
const SchoolDetail = () => import('../views/home/schoolDetail')
const LinkDetail = () => import('../views/home/linkDetail')
const Application = () => import('../views/order/application')
const MyOrder = () => import('../views/order/myOrder')
const Profile = () => import('../views/order/profile')
const OrderDetail = () => import('../views/order/orderDetail')
const QrCode = () => import('../views/login/qrCode')
const Login = () => import('../views/login/login')
const AccountLogin = () => import('../views/login/accountLogin')
const TrainOrderDetai = () => import('../views/order/trainOrderDetail')

Vue.use(VueRouter)

const routes = [
    {
        path:"/",
        name:"main",
        component:Main,
        redirect:"/index",
        meta:{title:"国际高等教育平台"},
        children:[
            {
                path:'/index',
                component:Home,
            },
            {
                path:'/schoolList',
                component:SchoolList
            },
            {
                path:'/schoolDetail',
                component:SchoolDetail
            },
            {
                path:'/linkDetail',
                component:LinkDetail
            },
            {
                path:'/application',
                component:Application,
                meta:{requireAuth:true},
            },
            {
                path:'/myOrder',
                component:MyOrder,
                meta:{requireAuth:true},
            },
            {
                path:'/profile',
                component:Profile,
                meta:{requireAuth:true},
            },
            {
                path:'/orderDetail',
                component:OrderDetail,
                meta:{requireAuth:true},
            } ,
            {
                path:'/trainOrderDetail',
                component:TrainOrderDetai,
                meta:{requireAuth:true},
            }

        ]
    },
    {
        path:'/qrCode',
        component:QrCode,
        meta:{title:"扫码登录"}
    },
    {
        path:'/login',
        component:Login,
        meta:{title:"登录"}
    },
    {
        path:'/accountLogin',
        component:AccountLogin,
        meta:{title:"账号登录"}
    },
    
]

const router = new VueRouter({
    routes,
    mode: 'history'
})

// 需要登录后可以访问的页面
router.beforeEach((to,from,next)=>{
    document.title = to.matched[0].meta.title
    if(to.meta.requireAuth){
        getWxUserInfo(()=>{
            if(store.state.isLogin){
                next()
            }else{
                let lastLink = window.location.href;
                sessionStorage.setItem('lastLink',lastLink)
                next({
                    path:'/login'
                })
            }
        })
    }else{
        next()
    }
})


// 切换页面都在顶部
router.afterEach((to,from,next) => {
    window.scrollTo(0,0);
})
export default router